export default __webpack_public_path__ + "static/media/hht1_ep17_minisitcom_01.b7f3adf9.png";